export const TAXONOMY_LIST_POST_REQUEST = "TAXONOMY_LIST_POST_REQUEST";
export const TAXONOMY_LIST_POST_RECEIVE = "TAXONOMY_LIST_POST_RECEIVE";
export const TAXONOMY_LIST_POST_FAILURE = "TAXONOMY_LIST_POST_FAILURE";
export const RESET_TAXONOMY_LIST_POST = "RESET_TAXONOMY_LIST_POST";
